<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-19 23:10:48
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="80px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="街道名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- <el-form-item label="所属街道" prop="wlStreetId" required="">
          <el-select v-model="form.wlStreetId" placeholder="请选择" clearable>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';
import { listMixin } from '@/mixins/listMixin';
import { getCommunityList, getStreetList } from '@/api/sign';

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      options: [],
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
      validatorRules: {
        name: [{ required: true, message: '请输入名称!' }],
        wlStreetId: [{ required: true, message: '请选择!' }],
      },
      url: {
        add: '/wlStreet/add',
        edit: '/wlStreet/update',
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    initDictConfig() {
      // getStreetList().then((res) => {
      //   this.options = res.data;
      // });
    },
    async doUpload(file) {
      let res = await this.uploadFile(file, 'wali/');
      this.$set(this.form, 'faceUrl', res);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPNG) && isLt2M;
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form = Object.assign({}, record);
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.form.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post'; //put
          }
          httpAction(httpurl, this.form, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功');
                that.$emit('ok');
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
